const translations = { title: 'Configuraciones de niveles de lugares' }

export default translations
